<template>
	<div>
		<!-- Staff view for unsent/unsigned contract -->
		<input
			v-if="isStaff && isEditable(true)"
			v-model="contract.provenance"
			:placeholder="'N/A'"
			maxlength="250"
			name="provenance"
			type="text"
		/>

		<!-- Read-only view for staff (sent/signed) or non-staff -->
		<div
			v-else
			class="contentBlock marginBottomSmall"
		>
			<div class="value">{{ displayProvenance }}</div>
		</div>
	</div>
</template>

<script>
	import contractState from '@/mixins/contractState'

	export default {
		name: 'Provenance',
		mixins: [contractState],
		props: {
			contract: {
				type: Object,
				required: true
			}
		},
		computed: {
			/**
			 * The display provenance
			 * @returns {string} The display provenance
			 */
			displayProvenance() {
				return this.contract.provenance || 'N/A'
			}
		},
		mounted() {}
	}
</script>

<style scoped></style>
